import type { IconProps } from "@/types/icon";

const Search = ({ color = "#64748B", className }: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.33317 1.66699C4.65127 1.66699 1.6665 4.65176 1.6665 8.33366C1.6665 12.0156 4.65127 15.0003 8.33317 15.0003C9.87376 15.0003 11.2923 14.4778 12.4212 13.6002L16.9106 18.0896C17.236 18.415 17.7637 18.415 18.0891 18.0896C18.4145 17.7641 18.4145 17.2365 18.0891 16.9111L13.5997 12.4217C14.4773 11.2928 14.9998 9.87425 14.9998 8.33366C14.9998 4.65176 12.0151 1.66699 8.33317 1.66699ZM3.33317 8.33366C3.33317 5.57224 5.57175 3.33366 8.33317 3.33366C11.0946 3.33366 13.3332 5.57224 13.3332 8.33366C13.3332 11.0951 11.0946 13.3337 8.33317 13.3337C5.57175 13.3337 3.33317 11.0951 3.33317 8.33366Z"
      fill={color}
    />
  </svg>
);
export default Search;
